import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

/**
 * Automations (flow schedules). Handler-gated like skills: the rail row wires
 * every handler; the pane kebab wires only run-now / duplicate / open-location
 * / delete (the header pill owns pause/resume there), so the same manifest
 * serves both surfaces.
 */
export const AUTOMATION: ObjectTypeConfig = {
  actions: [
    // Run-now is wired only where the backend endpoint is (pane + rail).
    {
      id: "run-now",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "edit",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    // Pause/Resume is a single toggle rendered as whichever state you'd
    // switch to — the skills Auto/Manual register.
    {
      id: "pause",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: { not: predicates.isAutomationActive },
    },
    {
      id: "resume",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.isAutomationActive,
    },
    {
      id: "duplicate",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "open-location",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
    {
      id: "delete",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
    },
  ],
};
